import React, { useMemo } from "react";
import style from "./index.module.scss";
import {
    CourseItem,
    getPlatformName,
    workState
} from "../../../../../../../../API";
import { isTrue } from "../../../../../../../../Utils/filter";
import { useHistory } from "react-router-dom";
import BadgeCor from "../BadgeCor";
import { Button, Tooltip } from "antd";
import { ResultMessage } from "components/ResultMessage";
import SubmitError from "../../../../../SubmitError";
import { evaluationStatus } from "../../../../../../../../API/evaluate";
import { courseDetailUrl } from "../../../../../../../../API/urls";
import useNeedEvaluation from "../../../../../../../../Utils/useNeedEvaluation";
import { getMeetingHrefProps } from "../../../../../../unitls";

interface DayCellProps {
    course?: CourseItem;
    dateTime: string;
}

export default function DayCell({ course, dateTime }: DayCellProps) {
    const history = useHistory();
    const { showModal, StopRouter } = useNeedEvaluation({
        weekTimeId: course?.weekTimeId,
        evaluationId: course?.evaluationId,
        evaluationType: course?.evaluationType
    });

    const alert = useMemo(() => {
        return (
            course?.evaluationStatus === evaluationStatus.NotEvaluated &&
            showModal
        );
    }, [course?.evaluationStatus, showModal]);

    const meetingBtn = useMemo(() => {
        if (!course) {
            return null;
        }

        return (
            <a {...getMeetingHrefProps(course)} className={style.liveAndScreen}>
                会议链接
            </a>
        );
    }, [course]);

    if (!course) return <div className={style.root} />;
    const {
        channelId,
        lmsCourseNo,
        courseUrl,
        isOpen,
        platformType,
        type: courseType
    } = course;

    function isHasThirdParty() {
        return isTrue(isOpen) && platformType !== "1";
    }

    function itemClickHandler(e: React.MouseEvent<HTMLElement>) {
        const target = e.target as HTMLElement;
        function jump() {
            if (target.tagName === "A") return;
            if (!course) return;
            history.push(
                courseDetailUrl(
                    course.courseNo,
                    course.courseSeq,
                    course.weekTimeId
                )
            );
        }
        if (alert) {
            StopRouter();
        } else {
            jump();
        }
    }

    // 是否有新活动提醒
    function hasBadge() {
        if (!course) return false;
        return (
            isTrue(course.signInStatus) ||
            isTrue(course.questionnaireStatus) ||
            isTrue(course.votePaperStatus) ||
            course.cousewareStudyStatus !== "0" ||
            (isTrue(course.studentExerciseStatus) &&
                isTrue(course.haveExercise))
        );
    }

    //前往直播
    function gotoLive(e: any) {
        e.stopPropagation();
        e.preventDefault();
        if (!channelId) {
            ResultMessage.error(<SubmitError />, { width: 350 });
        } else {
            if (alert) {
                StopRouter();
            } else {
                window.open(
                    `/student/goToPlay?channelId=${channelId}&userId=${localStorage.getItem(
                        "user"
                    )}&chapterCode=&versionCode=${lmsCourseNo}`
                );
            }
        }
    }

    //前往直播
    function goToHomework(e: any) {
        e.stopPropagation();
        e.preventDefault();
        if (alert) {
            StopRouter();
        } else {
            history.push("/homework");
        }
    }

    return (
        <div className={style.root} onClick={itemClickHandler}>
            <div className={style.wrapper}>
                <div className={style.courseName}>{course.courseName}</div>
                <div className={style.container}>
                    <div className={style.name}>
                        教师：
                        <Tooltip placement="topLeft" title={course.teacherName}>
                            {course.teacherName}
                        </Tooltip>
                    </div>

                    <div className={style.timeRange}>
                        时间：{course.beginTime} ~ {course.endTime}
                    </div>

                    <div className={style.address}>地点：{course.address}</div>
                </div>

                <BadgeCor
                    timeDate={dateTime}
                    startTime={course.beginTime}
                    endTime={course.endTime}
                />
                {hasBadge() && <div className={style.badge} />}
            </div>

            <div className={style.footer}>
                <div>
                    {course.homeworkStatus !== workState.NoHomework && (
                        <Button
                            type="link"
                            className={style.liveAndScreen}
                            onClick={e => goToHomework(e)}>
                            作业
                        </Button>
                    )}
                    {isHasThirdParty() && (
                        <a
                            target="_blank"
                            href={courseUrl}
                            className={style.liveAndScreen}
                            rel="noreferrer">
                            {getPlatformName(platformType)}
                        </a>
                    )}
                    {isTrue(course.meetingFlag) && meetingBtn}
                    {/*{!isHasThirdParty() && (*/}
                    {/*    <Button*/}
                    {/*        type="link"*/}
                    {/*        className={style.liveAndScreen}*/}
                    {/*        onClick={e => gotoLive(e)}>*/}
                    {/*        直播*/}
                    {/*    </Button>*/}
                    {/*)}*/}
                </div>
            </div>
        </div>
    );
}
